import PropTypes from "prop-types";
import * as React from "react";
import { offeredSignedTypes } from "../../../domain/productComposer/problems";
import SignType from "../../../domain/signType";
import ProblemList from "../sections/ProblemList";
import ServicesSection from "../sections/ServicesSection";
import SignTypePricing from "../sections/SignTypePricing";
import TagsSection from "../sections/TagsSection";
import css from "./create.module.css";

const PricingPage = function PricingPage({
  state,
  dispatch,
  productType,
  bumpFacts,
  isAdmin,
  user,
  problems,
  showErrors,
}) {
  const offered = offeredSignedTypes({
    signedTypes: SignType.list(),
    productType,
    user,
  });
  const signerIds = state.signers.map((s) => s.influencerId);
  const visibleSignerIds = isAdmin ? signerIds : [state.shop.influencerId];

  return (
    <div className={css.page}>
      <SignTypePricing
        state={state}
        dispatch={dispatch}
        signedTypes={offered}
        canToggle
        bumpFacts={bumpFacts}
        visibleSignerIds={visibleSignerIds}
        canManageSigners={isAdmin}
      />

      {showErrors && (
        <ProblemList problems={problems} title="Before you continue" />
      )}

      <TagsSection state={state} dispatch={dispatch} isAdmin={isAdmin} />

      <ServicesSection
        state={state}
        dispatch={dispatch}
        visibleSignerIds={visibleSignerIds}
      />
    </div>
  );
};

PricingPage.propTypes = {
  bumpFacts: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
  user: PropTypes.object.isRequired,
  problems: PropTypes.arrayOf(PropTypes.object).isRequired,
  productType: PropTypes.object,
  showErrors: PropTypes.bool,
  state: PropTypes.object.isRequired,
};

export default PricingPage;
